var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index"}},[_c('el-container',[_c('el-header',{staticStyle:{"padding":"0"}},[_c('app-header')],1),_c('el-container',{staticStyle:{"overflow":"hidden","zoom":"1","margin-top":"10px","background":"#fff"},style:(_vm.navHeight)},[_c('router-view')],1),_c('el-footer',{staticStyle:{"padding":"0"}},[_c('app-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }